import { Box, CircularProgress } from "@material-ui/core";
import moment, { Moment } from "moment";
import React, { useEffect, useRef, useState } from "react";
import Timeline from "react-visjs-timeline";
import { TimelineItem, TimelineOptions } from "vis-timeline";
import PlayerLayout from "../layout/player-layout";
import { AdDetailsCard } from "./components/AdSystemInfo";
import Card from "./components/card";
import Filter from "./components/filter";
import {
  CardsContainer,
  DateReference,
  PlayerArea,
  SearchButton,
  SearchButtonTypography,
  SearchKeyboardDateTimePicker,
  SearchWrapper,
  TimeControllerContainer,
  TimelineWrapper,
  TimeReference,
  ZoomButton,
} from "./styles";

import { axiosCallHandler } from "../../infra/axiosHelper";

import SearchIcon from "@material-ui/icons/Search";

import { ptBR } from "@material-ui/core/locale";
import "moment/locale/pt-br";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { BASE_URL } from "../../services/globoplay-api";
import useBreaksStore from "../../store/breaks";
import { getLocalStorageData } from "../../utils/auth";
import { UserData } from "../player/types";
import { BreakItem } from "./components/AdSystemInfo/types";
import LocationProfileContainer from "./components/LocationProfileContainer";
import { Player } from "./components/Player";
import "./style.css";
import DateFnsUtils from "@date-io/date-fns";
import isValid from "date-fns/isValid";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ZoomIn, ZoomOut } from "@material-ui/icons";
import { useDebounce } from "../../hooks/useDebounce";
import { useClipsStore } from "../../store/clips";
import SimulcastHlsPlayer from "./components/SimulcastHlsPlayer";

type ClippingSourceShape = {
  name: string;
  channel_label: string;
  channel_name: string;
  location_label: string;
  location_name: string;
  enabled: boolean;
};

const dateTimePickerFormat = "YYYY-MM-DD HH:mm:ss";

const Simulcast = () => {
  const {
    breaks,
    setBreak,
    getBreak,
    breaksArray,
    getBreaksArray,
    setBreaksArray,
    getBreakById,
    setPosition,
    getPosition,
    setHasSlate,
  } = useBreaksStore();

  const [data, setData] = useState<BreakItem[] | null>(); // Estado para armazenar os dados retornados
  const [loading, setLoading] = useState(false); // Estado para controlar o carregamento
  const [timelineItems, setTimelineItems] = useState<any[]>([]);
  const [timelineGroups, setTimelineGroups] = useState([]);
  // const [clips, setClips] = useState<Clip>();
  const clips = useClipsStore((s) => s.clips);
  //const [epochReference, setEpochReference] = useState<number>(Date.now());
  const epochReference = useRef<number>(Date.now());
  const [lastBreakItem, setLastBreakItem] = useState<BreakItem | null>(null);
  const [currentClipToDisplay, setCurrentClipToDisplay] = useState<
    ClippingSourceShape & { playerLabel: string }
  >();
  const currentSource = useRef<string | undefined>(undefined);

  const [clippings, setClippings] = useState<ClippingSourceShape[] | []>([]);
  const [filter, setFilter] = useState("");
  const [filteredClips, setFilteredClips] = useState<
    ClippingSourceShape[] | []
  >([]);
  const debouncedFilterTerm = useDebounce(filter, 600);

  const [isLoadingNewMidia, setIsLoadingNewMedia] = useState(true);

  const [selectedDate, setSelectedDate] = useState(
    moment().locale("pt-br").format(dateTimePickerFormat)
  );

  const [searchSelectedDate, setSearchSelectedDate] = useState(
    moment().locale("pt-br").format(dateTimePickerFormat)
  );

  //### Timeline
  const timelineRef = useRef<any>(null);

  const [currentZoomIndex, setCurrentZoomIndex] = useState(0); //Controla o index do zoom atual
  const currentZoomIndexRef = useRef(currentZoomIndex);
  currentZoomIndexRef.current = currentZoomIndex;

  const EXHIBITION_WINDOW_DURATION = [7200, 3600, 1200, 360];

  const lastSelectedSourceByUser = useRef("");

  const exhibitionWindowRef = useRef({
    currentStart: 0,
    currentTime: new Date().getTime(),
    currentEnd: 0,
  });

  const [currentDateTime, setCurrentDateTime] = useState(
    moment().subtract(3, "hours").unix() * 1000
  );

  const [timelineOptions] = useState<TimelineOptions>({
    width: "100%",
    height: "172px",
    stack: false,
    showMajorLabels: true,
    showCurrentTime: false,
    autoResize: false,
    zoomable: false,
    zoomFriction: 5,
    zoomMin: 360000,
    zoomMax: 7200000,
    type: "range",
    orientation: "top",
    locales: {
      pt_BR: {
        current: "pt_BR",
        time: "hora",
      },
    },
    locale: "pt_BR",
    showTooltips: false,
    
    tooltip: {
      template: function (item: TimelineItem, data?: TimelineItem) {
        if (item.group !== 1) {
          return "";
        } 
        let currentBreak = getBreaksArray().find((b) => ("" + item.id).startsWith(b.pod.id))
        if (!currentBreak) {
          return "";
        }
        console.log(currentBreak);
        return '<div class="tooltip-container"><div>' +  currentBreak.period_total_ads + '</div><div>' + Math.round(currentBreak.period_ads_duration || 0) + 'sec</div><div>' + Math.round(currentBreak.period_slate_duration || 0) + 'sec</div><div>' + Math.round(currentBreak.period_total_duration  || 0) + 'sec</div></div>'; 
      },
      overflowMethod: "cap",
      delay: 100
    }
  });

  //### Player
  type PlayerStatus = "loading" | "loaded" | "playing" | "paused";
  const playerRef = useRef<any>(null);

  const [currentPlayerStatus, setCurrentPlayerStatus] =
    useState<PlayerStatus>("loading"); //Controla o index do zoom atual
  const playerStatus = useRef(currentPlayerStatus);
  const fetchClips = useClipsStore((s) => s.fetchClips);
  const { setCurrentClipDuration, setCurrentClipDatetime } = useClipsStore();

  const { clearClips } = useClipsStore();

  const wasDragged = useRef(false);

  const [hasSelectedDate, setHasSelectedDate] = useState(true);

  const prevBreakRef = useRef<BreakItem | null>(null);

  function addRollDurationToDateByStringDate(date: string): Date {
    const rollDuration = Number(process.env.REACT_APP_BREAKS_ROLL_DURATION);
    return moment(date).add(rollDuration, "seconds").toDate();
  }

  function subtractRollDurationToDateByStringDate(date: string): Date {
    const rollDuration = Number(process.env.REACT_APP_BREAKS_ROLL_DURATION);
    return moment(date).subtract(rollDuration, "seconds").toDate();
  }

  function addIntervalDurationToDateByStringDate(date: string): Date {
    const rollDuration = Number(process.env.REACT_APP_BREAKS_INTERVAL_DURATION);
    return moment(date).add(rollDuration, "seconds").toDate();
  }

  function subtractIntervalDurationToDateByStringDate(date: string): Date {
    const rollDuration = Number(process.env.REACT_APP_BREAKS_INTERVAL_DURATION);
    return moment(date).subtract(rollDuration, "seconds").toDate();
  }

  const onUpdateCurrentBreakAndPosition = (datetime: number) => {
    if (playerRef.current) {
      playerRef.current?.pause();
      playerStatus.current = "paused";
    }
    exhibitionWindowRef.current.currentTime = datetime;
    timelineRef.current["$el"].moveTo(datetime);
    timelineRef.current["$el"].setCustomTime(datetime, 1);
    setCurrentDateTime(datetime);

    updatePlayer();
  };

  async function handleSearchAndPlayClipByTimestamp() {
    const exhibitionCurrentTime = new Date(selectedDate).getTime();

    if (isNaN(exhibitionCurrentTime)) {
      return;
    }

    playerRef.current?.pause();
    playerStatus.current = "paused";

    exhibitionWindowRef.current.currentTime = exhibitionCurrentTime;
    setCurrentDateTime(exhibitionCurrentTime);
    timelineRef.current["$el"].setCustomTime(exhibitionCurrentTime, 1);
    timelineRef.current["$el"].moveTo(exhibitionCurrentTime);

    const currentBreak = getBreaksArray().find((b) =>
      moment(exhibitionCurrentTime).isBetween(
        subtractRollDurationToDateByStringDate(b.pod.start_datetime),
        addRollDurationToDateByStringDate(
          b.slate ? b.slate.end_datetime : b.pod.end_datetime
        )
      )
    );

    //console.log("currentBreak", currentBreak);
    if (currentBreak) {
      //console.log("Found a break");

      const currentExhibition = currentBreak.pod.pod_exhibitions.find((ex) => {
        const start_datetime = ex.start_datetime == null ? currentBreak.pod.start_datetime : ex.start_datetime;
        const end_datetime = ex.end_datetime == null ? currentBreak.pod.end_datetime : ex.end_datetime;
        moment(exhibitionCurrentTime).isBetween(
          moment(start_datetime),
          moment(end_datetime)
        )
      });

      let hasSlate = false;
      if (currentBreak.slate) {
        hasSlate = moment(exhibitionCurrentTime).isBetween(
          moment(currentBreak.slate.start_datetime),
          moment(currentBreak.slate.end_datetime)
        );
      }

      setBreak(currentBreak);
      setPosition(currentExhibition ? currentExhibition.position : undefined);
      setHasSlate(hasSlate);

      updatePlayer();
    }
  }

  const updatePlayer = async () => {
    const breakItem = getBreak();
    console.log('BREAK',breakItem)
    const exhibitions = breakItem?.pod?.pod_exhibitions || [];
    const startDatetime = breakItem?.pod?.start_datetime;
    const endDatetime = breakItem?.pod?.end_datetime;

    if (!startDatetime || !endDatetime) return;

    console.log('startDatetime', startDatetime);
    const newStartDatetime =
      subtractIntervalDurationToDateByStringDate(startDatetime);
      console.log('newStartDatetime', newStartDatetime);
    const newEndDatetime = addRollDurationToDateByStringDate(
      breakItem.slate ? breakItem.slate.end_datetime : endDatetime
    );

    if (currentClipToDisplay?.name) {
      epochReference.current = newStartDatetime.getTime();

      if (
        !breakItem ||
        !breakItem.id ||
        prevBreakRef.current?.id === breakItem.id
      ) {
        seekToByReferences(
          moment(epochReference.current),
          moment(exhibitionWindowRef.current.currentTime)
        );
      } else {
        const duration = breakItem.period_total_duration ? 
              Math.max(
                Math.floor(breakItem.period_total_duration) +
                (Number(process.env.REACT_APP_BREAKS_INTERVAL_DURATION) * 2 || 0)
                , 
                (new Date(endDatetime).getTime() - new Date(startDatetime).getTime()) / 1000 + 
                (breakItem.slate?.duration || 0) + (Number(process.env.REACT_APP_BREAKS_INTERVAL_DURATION) * 2 || 0))
              :  
              (new Date(endDatetime).getTime() - new Date(startDatetime).getTime()) / 1000 +
              (breakItem.slate?.duration || 0) + (Number(process.env.REACT_APP_BREAKS_INTERVAL_DURATION) * 2 || 0);
        console.log(duration);
        setCurrentClipDuration(duration);
        setCurrentClipDatetime(epochReference.current);
        
        await fetchClips({
          profile: currentSource.current,
          datetime: epochReference.current,
          duration,
        });

        seekToByReferences(
          moment(epochReference.current),
          moment(exhibitionWindowRef.current.currentTime)
        );
      }
      prevBreakRef.current = breakItem;
    }
  };

  function seekToByReferences(fromDateTime: Moment, toStartDateTime: Moment) {
    console.log('seekToByReferences')
    const seek = moment
      .duration(toStartDateTime.diff(fromDateTime))
      .asSeconds();
    if (
      playerStatus.current !== "playing" &&
      !wasDragged.current &&
      playerRef.current
    ) {
      console.log(
        "if not playing and not dragged seek to ",
        fromDateTime,
        toStartDateTime,
        seek
      );
      playerRef.current.currentTime = seek;
      playerRef.current.play();
      
    }
  }

  /*useEffect(() => {

    updateTimeline();
  }, [
    getBreak,
    breaks,
    currentClipToDisplay?.name,
    currentClipToDisplay,
    clips,
  ]);*/

  const estimateCurrentDateTimeWithoutDelayToLive = (timestamp: number) => {
    // Obter a duração da janela de exibição (em segundos)
    const windowDurationInSeconds =
      EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] || 0;

    // Verificar se a duração da janela é válida
    if (windowDurationInSeconds === 0) {
      console.warn(
        "Duração da janela inválida. Retornando o timestamp original."
      );
      return new Date(timestamp);
    }

    // Calcular o deslocamento central (metade da janela de exibição)
    const offsetInMilliseconds = (windowDurationInSeconds / 2) * 1000;

    // Ajustar o timestamp para centralizar a timeline
    const currentTime = timestamp - offsetInMilliseconds;

    // Criar a data ajustada
    let date = new Date(currentTime);
    date.setMilliseconds(0);

    return date;
  };

  function handleZoomIn() {
    const maxCurrentZoomIndex = 3;
    if (currentZoomIndex === maxCurrentZoomIndex) {
      return;
    }
    let currentIndexCount = Math.min(
      currentZoomIndexRef.current + 1,
      maxCurrentZoomIndex
    );
    setCurrentZoomIndex(currentIndexCount);
    setTimelineWindow(EXHIBITION_WINDOW_DURATION[currentIndexCount] / 2);
  }

  function handleZoomOut() {
    if (currentZoomIndex === 0) {
      return;
    }
    let currentIndexCount = Math.max(currentZoomIndexRef.current - 1, 0);
    setCurrentZoomIndex(currentIndexCount);
    setTimelineWindow(EXHIBITION_WINDOW_DURATION[currentIndexCount] / 2);
  }

  const loadClippingSourcesAndRenderFirstClip = () => {
    if (!currentClipToDisplay) {
      playerStatus.current = "loaded";
      return;
    }

    playerStatus.current = "loaded";
  };

  //TODOOOO
  const setTimelineWindow = (halfWindow: number) => {
    console.log(exhibitionWindowRef.current.currentTime, halfWindow);
    let exhibitionWindowStart = moment(
      exhibitionWindowRef.current.currentTime
    ).subtract(halfWindow, "seconds");
    let exhibitionWindowEnd = moment(
      exhibitionWindowRef.current.currentTime
    ).add(halfWindow, "seconds");

    timelineRef?.current["$el"].setOptions({
      start: exhibitionWindowStart,
      end: exhibitionWindowEnd,
    });

    timelineRef.current["$el"].redraw();
  };

  const rangeChangedHandler = (e: any) => {
    if (!e.byUser) {
      return;
    }
    wasDragged.current = false;

    let exhibitionCurrentTime = estimateCurrentDateTimeWithoutDelayToLive(
      e.end.getTime()
    );

    exhibitionWindowRef.current.currentTime = exhibitionCurrentTime.getTime();
    setCurrentDateTime(exhibitionCurrentTime.getTime());

    const currentBreak = getBreaksArray().find((b) =>
      moment(exhibitionCurrentTime).isBetween(
        subtractRollDurationToDateByStringDate(b.pod.start_datetime),
        addRollDurationToDateByStringDate(
          b.slate ? b.slate.end_datetime : b.pod.end_datetime
        )
      )
    );

    if (currentBreak) {
      const currentExhibition = currentBreak.pod.pod_exhibitions.find((ex) => {
        const start_datetime = ex.start_datetime == null ? currentBreak.pod.start_datetime : ex.start_datetime;
        const end_datetime = ex.end_datetime == null ? currentBreak.pod.end_datetime : ex.end_datetime;
        moment(exhibitionCurrentTime).isBetween(
          moment(start_datetime),
          moment(end_datetime)
        )
      });

      let hasSlate = false;
      if (currentBreak.slate) {
        hasSlate = moment(exhibitionCurrentTime).isBetween(
          moment(currentBreak.slate.start_datetime),
          moment(currentBreak.slate.end_datetime)
        );
      }

      setBreak(currentBreak);
      setPosition(currentExhibition ? currentExhibition.position : undefined);
      setHasSlate(hasSlate);

      updatePlayer();
    }
  };

  const rangeChangeHandler = (e: any) => {
    if (!e.byUser) {
      return;
    }

    playerRef.current?.pause();
    playerStatus.current = "paused";

    let exhibitionCurrentTime = estimateCurrentDateTimeWithoutDelayToLive(
      e.end.getTime()
    );

    timelineRef?.current["$el"].setCustomTime(moment(exhibitionCurrentTime), 1);
    setSelectedDate(moment(exhibitionCurrentTime).format(dateTimePickerFormat));

    wasDragged.current = true;
  };

  function handleDateChange(date: Date | null) {
    if (!isValid(date)) {
      setHasSelectedDate(false);
      return;
    }
    setSelectedDate(date ? date.toISOString() : new Date().toISOString());
    setHasSelectedDate(true);
  }

  const handleSearch = () => {
    timelineRef.current["$el"].setCustomTime(searchSelectedDate, 1);
    timelineRef.current["$el"].moveTo(searchSelectedDate);
  };

  useEffect(() => {
    localStorage.removeItem("clips-storage");
    clearClips();
  }, [currentClipToDisplay?.name, clearClips]);

  useEffect(() => {
    loadClippingSourcesAndRenderFirstClip();
    let userData = getLocalStorageData();
    localStorage.removeItem("clips-storage");
    clearClips();

    axiosCallHandler({
      method: "GET",
      url: `/users/${userData?.username}`,
    }).then((currentUserServerData: UserData) => {
      axiosCallHandler({ method: "GET", url: "/clipping-sources" }).then(
        (res) => {
          let response: ClippingSourceShape[] = [];

          for (let i = 0; i < res.length; i++) {
            let item = res[i] as ClippingSourceShape;
            if (
              currentUserServerData.groups?.includes(item.name) &&
              item.enabled
            ) {
              response.push(item);
            }
          }

          setClippings(response);
          setFilteredClips(response);
        }
      );
    });

    window?.addEventListener("keydown", (e: any) => {
      if (e.target?.id === "filter-input") {
        return;
      }
    });
  }, []);

  function getLastDays() {
    const now = new Date();

    const days = process.env.REACT_APP_BREAKS_DAYS ? parseInt(process.env.REACT_APP_BREAKS_DAYS) : 30;

    const breaksDaysAgo = new Date(
      now.getTime() - days * 24 * 60 * 60 * 1000
    );

    const formatDate = (date: any) => {
      return `${date.getFullYear()}${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}${String(date.getDate()).padStart(2, "0")}${String(
        date.getHours()
      ).padStart(2, "0")}${String(date.getMinutes()).padStart(2, "0")}${String(
        date.getSeconds()
      ).padStart(2, "0")}`;
    };

    const nowFormatted = moment(now)
      .locale("pt-br")
      .format("YYYY-MM-DD HH:mm:ss");

    return {
      startDaysAgoDatetime: formatDate(breaksDaysAgo),
      endDaysAgoDatetime: formatDate(now),
      nowFormatted,
    };
  }

  const fetchBreaks = async (profileLabel: string) => {
    playerRef.current?.pause();
    playerStatus.current = "paused";
    setIsLoadingNewMedia(true);
    setLoading(true);

    const { startDaysAgoDatetime, endDaysAgoDatetime } = getLastDays();

    const url = `${BASE_URL}/dai-podding/sources/${profileLabel}/breaks?start_date_time_from=${startDaysAgoDatetime}&start_date_time_to=${endDaysAgoDatetime}`;

    try {
      const storage = getLocalStorageData();

      let result = await axiosCallHandler({
        method: "GET",
        url: url,
      });


      setData((prevData) => [...(prevData || []), ...(result || [])]); 
      setBreaksArray(result);

      
      //console.log(result);

      const groups : any = [{
        id: 1,
        content: 'Group A',
      }, {
        id: 2,
        content: 'Group B',
      }];
      setTimelineGroups(groups);

      const breaksItems : any = result.flatMap((item: any) => {
        if (!item.is_invalid) {
          let exhibitions = item.pod.pod_exhibitions.map(
            (exhibition: any, index: number) => {
              const startDate = new Date(exhibition.start_datetime);
  
              if (index + 1 < item.pod.pod_exhibitions.length) {
                exhibition.end_datetime =
                  item.pod.pod_exhibitions[index + 1].start_datetime;
              }
              if (index + 1 == item.pod.pod_exhibitions.length) {
                if (item.slate) {
                  exhibition.end_datetime = item.slate.start_datetime;
                }
              }
              const endDate = new Date(exhibition.end_datetime);
              if (exhibition.end_datetime == null) {
                console.log(exhibition, startDate.getTime() + (exhibition.creative.duration * 1000))
              }
  
              
              let className = exhibition.start_datetime == null || exhibition.end_datetime == null ? "failure-item " + item.pod.id + "-" + exhibition.position : item.pod.id + "-" + exhibition.position;
  
              return {
                id: `${item.pod.id}-${exhibition.position}`,
                content: ``,
                type: "range",
                group: 2,
                start: exhibition.start_datetime == null ? endDate.getTime() - (exhibition.creative.duration * 1000) : startDate.getTime(),
                end: exhibition.end_datetime == null ? startDate.getTime() + (exhibition.creative.duration * 1000) : endDate.getTime(),
                selectable: true,
                className: className,
              };
            }
          );
          const slateItem = item.slate
            ? [
                {
                  id: `${item.pod.id}-slate`,
                  content: "",
                  type: "range",
                  group: 2,
                  start: new Date(item.slate.start_datetime).getTime(),
                  end: new Date(item.slate.end_datetime).getTime(),
                  selectable: true,
                  className: `slate-item ${item.pod.id}-slate`,
                }, 
              ]
            : [];
          return exhibitions.concat(slateItem);
        } else {
          return [];
        }

        
      });


      // Early Ad Break Notifications (EABN)
      const eabnItems : any = result.flatMap( (item: any) => {
        if (!item.is_invalid) {
          return {
            id: `${item.id}-eabn`,
              content: item.pod.pod_exhibitions ? item.pod.pod_exhibitions.length.toString() : item.period_total_ads.toString(),
              type: "range",
              group: 1,
              start: new Date(item.pod.start_datetime).getTime(),
              end: new Date(item.slate?.end_datetime).getTime() >  new Date(item.pod.end_datetime).getTime() ? new Date(item.slate.end_datetime).getTime() : new Date(item.pod.end_datetime).getTime(),
              selectable: false,
              className: `eabn-item ${item.id}-eabn`,
          }
        } else {
          return [];
        }
      });

      const periodItems : any = result.flatMap((period: any) => {
        if (period.period_slate_duration == null) {
          if (period.slate == null) {
            return {
              id: `${period.id}-period`,
              content: period.period_total_ads ? period.period_total_ads.toString()  : "",
              type: "range",
              group: 1,
              start: new Date(period.pod.start_datetime).getTime(),
              end: new Date(period.pod.end_datetime).getTime(),
              selectable: false,
              className: `period-item ${period.id}-period`,
            }
          } else {
            return [{
              id: `${period.id}-period`,
              content: period.period_total_ads ? period.period_total_ads.toString()  : "",
              type: "range",
              group: 1,
              start: new Date(period.pod.start_datetime).getTime(),
              end: new Date(period.pod.end_datetime).getTime(),
              selectable: false,
              className: `period-item ${period.id}-period`,
            },{
              id: `${period.id}-period-slate`,
              content: "",
              type: "range",
              group: 1,
              start: new Date(period.pod.end_datetime).getTime(),
              end: new Date(period.pod.end_datetime).getTime() + (new Date(period.slate.end_datetime).getTime() - new Date(period.slate.start_datetime).getTime()),
              selectable: false,
              className: `period-slate-item ${period.id}-period-slate`,
            }]
          }
         
        } else if (period.period_slate_duration > 1.0) {
          if (!period.is_invalid) {
            let isInvalidClassName = period.is_invalid ? 'period-item-is-invalid' : '';
            let periodStartDatetime = new Date(period.pod.start_datetime).getTime();
            let periodAdsDuration = period.period_ads_duration * 1000;
            let periodSlateDuration = period.period_slate_duration * 1000;
            return [{
              id: `${period.id}-period`,
              content: period.period_total_ads ? period.period_total_ads.toString()  : "",
              type: "range",
              group: 1,
              start: periodStartDatetime,
              end: periodStartDatetime + periodAdsDuration,
              selectable: false,
              className: `period-item ${period.id}-period ${isInvalidClassName}`,
            },
            {
              id: `${period.id}-period-slate`,
              content: "",
              type: "range",
              group: 1,
              start: periodStartDatetime + periodAdsDuration,
              end: periodStartDatetime + periodAdsDuration + periodSlateDuration,
              selectable: false,
              className: `period-slate-item ${period.id}-period-slate ${isInvalidClassName}`,
            }]
          } else {
            return [];
          }
        } else {
          if (!period.is_invalid) {
            let isInvalidClassName = period.is_invalid ? 'period-item-is-invalid' : '';
            let periodStartDatetime = new Date(period.pod.start_datetime).getTime();
            let periodTotalDuration = period.period_total_duration * 1000;
            return {
              id: `${period.id}-period`,
              content: period.period_total_ads ? period.period_total_ads.toString()  : "",
              type: "range",
              group: 1,
              start: periodStartDatetime,
              end: periodStartDatetime + periodTotalDuration,
              selectable: false,
              className: `period-item ${period.id}-period ${isInvalidClassName}`,
            }
          } else {
            return [];
          }
        }
        return periodItems;
        
      });
      console.log(breaksItems);
      console.log(periodItems);
      console.log(eabnItems);

      const items : any = [...eabnItems,...breaksItems];
      
      setTimelineItems(items);

      const currentDateTime = new Date().getTime() - 3 * 60 * 60 * 1000;
      exhibitionWindowRef.current.currentTime = currentDateTime;
      setCurrentDateTime(currentDateTime);

      setBreak(result[Math.max(0, result.length - 10)]);

      if (!timelineRef.current["$el"].customTimes[0]) {
        timelineRef.current["$el"].addCustomTime(currentDateTime, 1);
      }

      timelineRef.current["$el"].setCustomTime(currentDateTime, 1);
      timelineRef.current["$el"].moveTo(currentDateTime);

      return result;
    } catch (error) {
      console.log(error); // Define a mensagem de erro
    } finally {
      setIsLoadingNewMedia(false);
      setLoading(false); // Finaliza o carregamento
    }
  };

  const fetchClipsOld = async (
    profile: string | undefined,
    datetime: number,
    duration: number
  ) => {
    setIsLoadingNewMedia(true);
    setLoading(true);
    const clipsUrl = `${BASE_URL}/clips?source_name=${profile}&datetime_from=${datetime}&duration=${duration}`;
    
    try {
      const storage = getLocalStorageData();

      const data = await axiosCallHandler({
        method: "POST",
        url: clipsUrl,
      });
      // setClips(data);
    } catch (error) {
      console.log(error);
      // setClips(undefined);
    } finally {
      setLoading(false);
      setIsLoadingNewMedia(false);
    }
  };

  function splitIdAndPosition(texto: string): {
    id: string;
    position: number | undefined;
    hasSlate: boolean;
  } {
    if (!texto || !texto.includes("-")) {
      console.warn("Texto inválido. O formato esperado é 'id-position'.");
      return { id: "", position: undefined, hasSlate: false }; // Retorna valores padrão
    }

    const partes = texto.split("-"); // Divide a string pelo hífen
    const position = partes.pop(); // Remove o último item (posição)

    if (position === undefined) {
      throw new Error("A posição não foi encontrada.");
    }

    const id = partes.join("-"); // Junta o resto da string (ID)

    if (position === "slate") {
      return { id, position: undefined, hasSlate: true };
    }

    return { id, position: parseInt(position), hasSlate: false }; // Retorna o ID e a posição como número
  }

  const updateCurrentDatetime = (time: number) => {
    let accumulatedTime = 0;

    const rollDuration =
      Number(process.env.REACT_APP_BREAKS_ROLL_DURATION) * 2 || 0;

    const position = getPosition();
    const exhibitions = breaks?.pod?.pod_exhibitions || [];

    const selectedExhibition = exhibitions[position - 1];

    if (!selectedExhibition) {
      return null;
    }

    for (const item of exhibitions) {
      const adjustedDuration = item.creative.duration * 1000 + rollDuration;

      if (accumulatedTime + adjustedDuration >= time) {
        const baseTime = new Date(item.start_datetime).getTime();
        const calculatedTime = new Date(baseTime + (time - accumulatedTime));

        setSelectedDate(calculatedTime.toISOString());

        return calculatedTime;
      }

      accumulatedTime += adjustedDuration;
    }

    return null;
  };

  async function clickHandler(props: any) {
    if (props.what !== "item") {
      return;
    }

    console.log('CLICK HANDLER')

    playerRef.current?.pause();
    playerStatus.current = "paused";
    const idAndPosition = splitIdAndPosition(props.item);

    const breakItem = getBreakById(idAndPosition?.id);

    if (breakItem && idAndPosition) {
      setBreak(breakItem);
      setPosition(idAndPosition.position);
      setHasSlate(idAndPosition.hasSlate);

      const time = idAndPosition?.position
        ? breakItem?.pod.pod_exhibitions[idAndPosition?.position - 1]
            .start_datetime ? breakItem?.pod.pod_exhibitions[idAndPosition?.position - 1]
            .start_datetime : breakItem?.pod.start_datetime
        : breakItem?.slate?.start_datetime;

      if (time) {
        timelineRef.current["$el"].setCustomTime(time, 1);
        timelineRef.current["$el"].moveTo(time);
        exhibitionWindowRef.current.currentTime = new Date(time).getTime();
        setCurrentDateTime(new Date(time).getTime());

        updatePlayer();
      }
    }
  }

  function handlePlaySeeked(e: any) {
    const video = e.target;

    if (!video || !video.currentTime || !video.duration) {
      return;
    }

    if (!breaksArray || breaksArray.length === 0) {
      console.warn("breaksArray está vazio ou indefinido!", breaksArray);
      return;
    }

    const exhibitionCurrentTime =
      epochReference.current + e.target.currentTime * 1000;

    const currentBreak = breaksArray.find((b) =>
      moment(exhibitionCurrentTime).isBetween(
        moment(b.pod.start_datetime),
        moment(b.pod.end_datetime)
      )
    );

    if (currentBreak) {
      const currentExhibition = currentBreak.pod.pod_exhibitions.find((ex) =>
        moment(exhibitionCurrentTime).isBetween(
          moment(ex.start_datetime),
          moment(ex.end_datetime)
        )
      );

      let hasSlate = false;
      if (currentBreak.slate) {
        hasSlate = moment(exhibitionCurrentTime).isBetween(
          moment(currentBreak.slate.start_datetime),
          moment(currentBreak.slate.end_datetime)
        );
      }
    }

    const exhibitionCurrentStart =
      exhibitionCurrentTime -
      (EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2) * 1000;
    const exhibitionCurrentEnd =
      exhibitionCurrentTime +
      (EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2) * 1000;

    timelineRef?.current["$el"].setOptions({
      start: exhibitionCurrentStart,
      end: exhibitionCurrentEnd,
    });
    timelineRef?.current["$el"].setCustomTime(exhibitionCurrentTime, 1);
    timelineRef?.current["$el"].redraw();
  }

  const handleFilter = () => {
    if (debouncedFilterTerm === "") {
      setFilteredClips(clippings);
      return;
    }

    let filteredList = clippings.filter(
      (clip) =>
        clip.location_label
          .toLowerCase()
          .includes(debouncedFilterTerm.toLowerCase()) ||
        clip.channel_label
          .toLowerCase()
          .includes(debouncedFilterTerm.toLowerCase())
    );

    setFilteredClips(filteredList);
  };
  useEffect(handleFilter, [debouncedFilterTerm]);

  function handleTimeUpdate(e: any) {
    if (playerStatus.current === "paused") {
      return;
    }

    if (playerStatus.current === "loaded") {
      return;
    }

    const video = e.target;

    if (!video || !video.currentTime || !video.duration) {
      return;
    }

    if (!breaksArray || breaksArray.length === 0) {
      console.warn("breaksArray está vazio ou indefinido!", breaksArray);
      return;
    }

    const exhibitionCurrentTime =
      epochReference.current + e.target.currentTime * 1000;
    exhibitionWindowRef.current.currentTime = exhibitionCurrentTime;
    setCurrentDateTime(exhibitionCurrentTime);

    const currentBreak = getBreaksArray().find((b) =>
      moment(exhibitionCurrentTime).isBetween(
        moment(b.pod.start_datetime),
        moment(b.pod.end_datetime)
      )
    );

    if (currentBreak) {
      const currentExhibition = currentBreak.pod.pod_exhibitions.find((ex) => {
        return moment(exhibitionCurrentTime).isBetween(
          ex.start_datetime != null ? moment(ex.start_datetime) : moment(ex.end_datetime).add(ex.creative.duration, "seconds"),
          ex.end_datetime != null ? moment(ex.end_datetime) : moment(ex.start_datetime).add(ex.creative.duration, "seconds"),
        );
        }
      );

      let hasSlate = false;
      if (currentBreak.slate) {
        hasSlate = moment(exhibitionCurrentTime).isBetween(
          moment(currentBreak.slate.start_datetime),
          moment(currentBreak.slate.end_datetime)
        );
      }

      if (currentExhibition && currentExhibition.position != getPosition()) {
        setPosition(currentExhibition.position);
      }
    }

    const exhibitionCurrentStart =
      exhibitionCurrentTime -
      (EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2) * 1000;
    const exhibitionCurrentEnd =
      exhibitionCurrentTime +
      (EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2) * 1000;

    timelineRef?.current["$el"].setOptions({
      start: exhibitionCurrentStart,
      end: exhibitionCurrentEnd,
    });
    timelineRef?.current["$el"].setCustomTime(exhibitionCurrentTime, 1);
    timelineRef?.current["$el"].redraw();
  }

  return (
    <div>
      <ThemeProvider theme={(outerTheme) => createTheme(outerTheme, ptBR)}>
        <PlayerLayout>
          <div style={{ height: "100dvh", width: "100%" }}>
            <SearchWrapper>
              <Filter
                value={filter}
                onChange={setFilter}
                id="filter-input"
                placeholder="Escolher perfil"
              />
            </SearchWrapper>
            <CardsContainer>
              {filteredClips?.map((clip) => {
                return (
                  <Card
                    {...clip}
                    isFocused={currentClipToDisplay?.name === clip.name}
                    key={clip.name}
                    label={clip.location_label}
                    text={clip.channel_label}
                    setCurrentClip={(clipName) => {
                      setCurrentClipToDisplay(clipName);
                      currentSource.current = clipName.name.replace(/-/g, "");
                      fetchBreaks(clipName.name.replace(/-/g, ""));
                      // setClips(undefined);
                      lastSelectedSourceByUser.current = clipName;
                    }}
                  />
                );
              })}
            </CardsContainer>
          </div>
          <PlayerArea>
            {playerStatus.current === "loading" ? (
              <CircularProgress disableShrink />
            ) : (
              currentClipToDisplay && (
                <React.Fragment>
                  <LocationProfileContainer
                    profile={currentClipToDisplay.playerLabel}
                  />
                  <div className="player-container">
                    {clips ? (
                        <SimulcastHlsPlayer
                          src={clips?.address}
                          style={{
                            width: "100%",
                          }}
                          autoPlay={false}
                          controls={true}
                          playerRef={playerRef}
                          width="100%"
                          height="auto"
                          onPause={() => (playerStatus.current = "paused")}
                          onPlay={() => {playerStatus.current = "playing"}}
                          onSeeked={handlePlaySeeked}
                          onTimeUpdate={handleTimeUpdate}
                        />
                    ) : (
                      <Player />
                    )}
                    {getBreaksArray() && (
                      <AdDetailsCard
                        onUpdateCurrentBreakAndPosition={
                          onUpdateCurrentBreakAndPosition
                        }
                        profile={currentClipToDisplay.playerLabel}
                        name={currentSource.current ?? "UNKNOWN"}
                      />
                    )}
                  </div>
                  <section style={{ width: "100%" }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <SearchKeyboardDateTimePicker
                        id="datetimepicker"
                        value={selectedDate}
                        onChange={handleDateChange}
                        format="dd/MM/yyyy HH:mm:ss"
                        disableFuture
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        maxDateMessage="Data inválida"
                        InputProps={{
                          disableUnderline: true,
                          style: { padding: "0px 10px", height: "26px" },
                        }}
                        InputAdornmentProps={{
                          style: { display: "none" },
                        }}
                        disableToolbar
                      />
                    </MuiPickersUtilsProvider>

                    <SearchButton
                      onClick={handleSearchAndPlayClipByTimestamp}
                      disabled={!hasSelectedDate}
                      startIcon={<SearchIcon />}
                    >
                      <SearchButtonTypography className="search-button">
                        Pesquisar
                      </SearchButtonTypography>
                    </SearchButton>
                  </section>

                  <TimelineWrapper
                    isLoadingNewContent={isLoadingNewMidia}
                    style={{ width: "100%" }}
                  >
                    <div className="loader-wrapper">
                      <div className="loader"></div>
                    </div>
                    {currentClipToDisplay && (
                      <Box id="simulcast-timeline">
                        <Timeline
                          ref={timelineRef}
                          options={timelineOptions}
                          items={timelineItems}
                          groups={timelineGroups}
                          selectable
                          clickToUse
                          clickHandler={clickHandler}
                          rangechangeHandler={rangeChangeHandler}
                          rangechangedHandler={rangeChangedHandler}
                        />
                      </Box>
                    )}
                  </TimelineWrapper>

                  <TimeControllerContainer>
                    <TimeReference>
                      {moment(currentDateTime).format("HH:mm:ss")}
                    </TimeReference>
                    <DateReference>
                      {moment(currentDateTime)
                        .locale("pt-br")
                        .format("dddd DD [de] MMMM")}
                    </DateReference>
                    <section className="zoom-controller">
                      <ZoomButton
                        onClick={handleZoomOut}
                        disabled={currentZoomIndex === 0}
                      >
                        <ZoomOut />
                      </ZoomButton>
                      <ZoomButton
                        onClick={handleZoomIn}
                        disabled={currentZoomIndex === 3}
                      >
                        <ZoomIn />
                      </ZoomButton>
                    </section>
                  </TimeControllerContainer>
                </React.Fragment>
              )
            )}
          </PlayerArea>
        </PlayerLayout>
      </ThemeProvider>
    </div>
  );
};

export default Simulcast;
